// extracted by mini-css-extract-plugin
module.exports = {"wrap":"OurStory_wrap__1S9b7","about":"OurStory_about__10den"};